(() => {
  const imageOnlyClass = 'hf-product-grid--images-only';
  const storageKey = 'hushfoot-ab-socks-grid-mode';

  const getElements = () => ({
    control: document.querySelector('[data-hf-ab-view-control]'),
    root: document.querySelector('[data-hf-ab-socks-collection]'),
  });

  const getSavedMode = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'images' ? 'images' : 'default';
    } catch (error) {
      return 'default';
    }
  };

  const saveMode = (mode) => {
    try {
      window.localStorage.setItem(storageKey, mode);
    } catch (error) {
      return;
    }
  };

  const sync = (mode) => {
    const { control, root } = getElements();
    if (!control || !root) return;

    const grid = root.querySelector('#product-grid');
    if (grid) {
      grid.classList.toggle(imageOnlyClass, mode === 'images');
      grid.dataset.hfGridMode = mode;
    }

    control.querySelectorAll('[data-hf-grid-mode]').forEach((option) => {
      const isSelected = option.dataset.hfGridMode === mode;
      option.setAttribute('aria-checked', String(isSelected));
      option.classList.toggle('is-selected', isSelected);
    });
  };

  const closeMenu = () => {
    const { control } = getElements();
    if (!control) return;

    const trigger = control.querySelector('[data-hf-ab-view-trigger]');
    const menu = control.querySelector('[data-hf-ab-view-menu]');
    if (!trigger || !menu) return;

    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove('is-open');
    menu.hidden = true;
  };

  const init = () => {
    const { control, root } = getElements();
    if (!control || !root) return;

    const mode = root.dataset.hfGridMode || getSavedMode();
    root.dataset.hfGridMode = mode;
    sync(mode);

    if (!root.dataset.hfGridObserver) {
      const observer = new MutationObserver(() => sync(root.dataset.hfGridMode || 'default'));
      observer.observe(root, { childList: true, subtree: true });
      root.dataset.hfGridObserver = 'true';
    }
  };

  document.addEventListener('click', (event) => {
    const { control, root } = getElements();
    if (!control || !root) return;

    const trigger = event.target.closest('[data-hf-ab-view-trigger]');
    if (trigger && control.contains(trigger)) {
      const menu = control.querySelector('[data-hf-ab-view-menu]');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      trigger.classList.toggle('is-open', !isOpen);
      menu.hidden = isOpen;
      return;
    }

    const option = event.target.closest('[data-hf-grid-mode]');
    if (option && control.contains(option)) {
      const mode = option.dataset.hfGridMode === 'images' ? 'images' : 'default';
      root.dataset.hfGridMode = mode;
      saveMode(mode);
      sync(mode);
      closeMenu();
      return;
    }

    if (!control.contains(event.target)) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });

  document.addEventListener('DOMContentLoaded', init);
  init();
})();
